export function isPing(text: string): boolean {
  const pattern = /^@[a-zA-Z0-9_.-]+$/gm
  const match = text.match(pattern)
  return !!match
}
